import { ArrowUpRightIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";

import { ExclamationCircleIcon } from "../../atoms/icons/ExclamationCircleIcon";

const HowItWorksCard = () => {
  const { t } = useTranslation();
  const steps = [
    {
      title: t("page.giftVouchers.howItWorksCard.steps.0.title"),
      description: t("page.giftVouchers.howItWorksCard.steps.0.description"),
    },
    {
      title: t("page.giftVouchers.howItWorksCard.steps.1.title"),
      description: t("page.giftVouchers.howItWorksCard.steps.1.description"),
    },
    {
      title: t("page.giftVouchers.howItWorksCard.steps.2.title"),
      description: t("page.giftVouchers.howItWorksCard.steps.2.description"),
    },
    {
      title: t("page.giftVouchers.howItWorksCard.steps.3.title"),
      description: t("page.giftVouchers.howItWorksCard.steps.3.description"),
    },
  ];

  return (
    <div className="relative flex h-full flex-col">
      <div className="absolute inset-0 overflow-y-auto rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="text-secondary-500 mb-6 text-lg font-bold">
          {t("page.giftVouchers.howItWorksCard.title")}
        </div>
        <ol className="relative ml-4 border-l border-gray-300">
          {steps.map((step, index) => (
            <li key={index} className="mb-8 ml-6">
              <div className="bg-secondary-25 text-secondary-700 absolute -left-4 flex size-8 items-center justify-center rounded-full text-base font-semibold">
                {index + 1}
              </div>
              <div className="text-sm font-semibold text-gray-950">
                {step.title}
              </div>
              <div className="mt-1 text-xs text-gray-500">
                {step.description}
              </div>
            </li>
          ))}
        </ol>
        <div className="mt-6 flex max-w-[29.5rem] flex-col items-center justify-center rounded-xl bg-gray-100 p-3 text-sm text-gray-700 md:flex-row">
          <div className="flex gap-3">
            <ExclamationCircleIcon pathClassName="stroke-gray-500" />
            <div className="text-sm font-medium text-gray-950">
              {t("page.giftVouchers.howItWorksCard.readMore")}
            </div>
          </div>
          <a
            href="https://support.gymflow.io/en/collections/0967771-gift-vouchers"
            target="_blank"
            rel="noreferrer"
            className="ml-auto flex items-center gap-1 font-medium text-purple-600 hover:underline"
          >
            <div className="flex flex-row flex-nowrap items-center justify-center">
              <div className="text-nowrap">
                {t("page.giftVouchers.howItWorksCard.openArticle")}
              </div>
              <ArrowUpRightIcon className="size-6" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksCard;
